import React from 'react'
import classNames from 'classnames'
import GA from '../../shared/tracking/ga'
import Toggle from './toggle'
import * as API from '../../service/user'
import {getCustomFormStyle} from '../../service/custom-form-style'
import Button from '../common/button'
import {FormLogin, FormPasswordRecovery, FormRegistration, FormSMS} from './form-states'
import GiftContext from '../../context/context'
import analytics from '../../shared/analytics'
import {FORM_LOGIN, FORM_MOBILE_START, FORM_PASSWORD_RECOVERY, FORM_SIGNUP, FORM_SMS,} from '../../shared/formStates'

import isMobile from '../../shared/isMobile'
import {FOUNDERS_MODE, MMC_MODE, PROMO_MODE, REFERRAL_MODE, RISE_MODE} from '../../shared/modes'
import {CONTENT_ADDCARD, CONTENT_DONE} from '../../shared/contentStates'

import {trackSendFormError} from './analytics'

import './styles.sass'
import {salesForceCodeSendApi} from '../../service/api'
import Turnstile from "react-turnstile/"
import {countriesList} from "./texts/select-static-data";

const TURNSTILE_API_KEY = '0x4AAAAAAAA0_OvNb1d2NLNL'
const doubleCodeRedeemMap = {
  'WELCOMEGORDONC': 'GordonC',
  'WELCOMENICKH': 'nickh',
  'WELCOMEADAMP': 'adamp',
  'WELCOMEDAVIDP': 'davidp',
  'WELCOMEDANE': 'daniele',
  'WELCOMEAUSTINO': 'austino',
  'WELCOMECOLBYC': 'colbyc',
  'WELCOMEJOHNR': 'johnr',
  'WELCOMEYOUSSEFM': 'youssefm',
  'WELCOMENICKOLAYY': 'nickolayy',
  'WELCOMEDAVIDA': 'davida',
  'WELCOMEYULIYAL': 'yuliyal',
  'WELCOMEIVANS': 'ivans',
  'WELCOMEALEXH': 'alexh',
  'WELCOMENATHAND': 'nathand',
  'WELCOMESHEMEEMK': 'shemeemk',
  'WELCOMESALMAA': 'salmaa',
  'WELCOMEAMRA': 'amra',
  'WELCOMESAKKEERH': 'sakkeerh',
  'WELCOMESOUKAINAA': 'soukainaa',
  'WELCOMECARMENE': 'carmene',
  'WELCOMEANASTASIAM': 'anastasiam',
  'WELCOMEMAJIDM': 'majidm',
  'WELCOMEKHEMSANGC': 'khemsangc'
}

class GiftForm extends React.Component {
  static contextType = GiftContext

  wrapper = React.createRef()

  state = {
    isLoading: false,
    formState: null,
    recoveryMessage: null,
    withCAPTCHA: false,
    membershipAgreed: false,
  }

  signUpData = {
    email: '',
    phone: '',
    password: '',
    name: '',
    country: '',
    state: '',
    gdpr: '',
    code: this.context.formData.code,
    source: this.context.formData.mode,
  }

  componentDidMount() {
    let initFormState

    if ([RISE_MODE, FOUNDERS_MODE].includes(this.context.formData.mode)) {
      if (isMobile) initFormState = FORM_MOBILE_START
      else initFormState = FORM_LOGIN
    } else initFormState = FORM_SIGNUP

    this.setState({formState: initFormState})
  }

  get currentForm() {
    const {code} = this.context.formData
    const forms = {
      signup: <FormRegistration questionnaire={this.props?.content?.questionnaire || []} code={code}/>,
      login: <FormLogin onChangeForm={this.handleChangeForm}/>,
      passwordRecovery: (
        <FormPasswordRecovery
          onChangeForm={this.handleChangeForm}
          recoveryMessage={this.state.recoveryMessage}
        />
      ),
      smscode: <FormSMS handleBack={this.switchAllContent} sendSMS={this.sendSMS}/>,
      start: <div/>,
    }
    return forms[this.state.formState]
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.content?.for_login_only && !prevState.formState && prevState.formState !== this.state.formState) {
      this.switchAllContent()
    }
  }

  setLoading = (bool) => this.setState({isLoading: bool})

  handleChangeForm = (formState) => {
    this.wrapper.current.classList.add('animation')
    setTimeout(() => {
      this.context.cleanErrors()
      this.setState({formState})
      this.wrapper.current.classList.remove('animation')
    }, 200)
  }

  switchAllContent = () => {
    this.props.switchContent(
      this.state.formState === FORM_SIGNUP ? FORM_LOGIN : FORM_SIGNUP,
      this.wrapper.current
    )

    this.handleChangeForm(this.state.formState === FORM_SIGNUP ? FORM_LOGIN : FORM_SIGNUP)
  }

  // prepare data for sending

  compareData = () => {
    const {email, password, name, phone, isGdpr, mode, country, state} = this.context.formData
    const clearPhone = phone.replace(/\D/g, '')
    this.signUpData = {...this.signUpData, name, email, password, phone: clearPhone, gdpr: isGdpr, country}

    if (state){
      this.signUpData.state = state
    }

    if (mode === FOUNDERS_MODE) {
      this.signUpData.source = 'rise_activate_founders_promo'
    }
    if (mode === MMC_MODE) {
      this.signUpData.source = 'rise_activate_mmc_promo'
    }
  }

  // button handler and form actions

  handleSubmit = (ev) => {
    ev.preventDefault()
    const {formState} = this.state
    this.setLoading(true)
    if (formState === FORM_MOBILE_START) this.start()
    if (formState === FORM_LOGIN) this.login()
    if (formState === FORM_SMS) this.register()
    if (formState === FORM_SIGNUP) this.signUp()
    if (formState === FORM_PASSWORD_RECOVERY) this.recoveryPassword()
  }

  signUp = (captcha) => {
    const {
      validate,
      formData,
    } = this.context
    if (validate(this.state.formState)) {
      this.checkEmail(formData, captcha)
    } else {
      trackSendFormError()
      this.setLoading(false)
    }
  }

  checkEmail = async (formData, captcha) => {
    const {
      userSmsCode,
      name,
      email,
      phone,
      state,
      country,
      password
    } = formData
    try {
      const captchaToken =  window.localStorage.getItem('captcha-token') || ''
      const obj = {
        "currency": "USD",
        "timeIs24hrs": true,
        "smsCode": userSmsCode || "",
        "personalData": {
          "fullName": name || "",
          "email": email || "",
          "phone": phone.replace(/\D/g, '') || "",
          "country": countriesList.find(item => item.name === country)?.code.toUpperCase() || 'US',
        },
        "captchaResponse": captcha ? captcha : '',
        "captchaToken": captchaToken,
        "password": password,
        "registrationPage": document.location.href,
        "registrationSource": "promo"
      }
      if (state){
        obj.personalData.state = state
      }
      return await API.registerV2(obj)
    } catch (e) {
      this.setLoading(false)
      if (e?.message === 'Captcha verification needed'){
        localStorage.removeItem('captcha-token')
        if(formData.userSmsCode){
          this.context.handleChangeField('userSmsCode', '')
          this.switchAllContent()
        }
        this.setState({
          withCAPTCHA: true,
        })
      }
      else if (e?.message === 'SMS verification needed'){
        this.sendSMS(false)
      }
      else {
        this.props.errorModal(e)
      }
    }
  }

  sendSMS = async (resend) => {
    if (resend) {
      this.context.handleChangeField('userSmsCode', '')
      setTimeout(()=>{
        this.signUp('')
      },0)
      GA.send({
        name: 'send_sms',
        category: 'sms_confirmation',
        action: 'send_again',
      })
    }
    else if (this.context.validate(this.state.formState) && this.state.formState !== FORM_SMS) {
      this.handleChangeForm(FORM_SMS)
    } else {
      this.setLoading(false)
    }
  }

  sendToOneTrust = async () => {
    await API.sendToOneTrust(this.signUpData)
  }
  register = async () => {
    if (this.context.validate(this.state.formState)) {
      this.compareData()
      try {
        const res = await this.checkEmail(this.context?.formData)
        if(res){
          if (res?.clientId) {
            analytics.sendID(res.clientId.toString(), 'CompleteRegistration')
          }
          analytics.registrationSuccess(
            this.signUpData.email,
            this.signUpData.code,
            this.signUpData.name,
            this.signUpData.phone
          )
          this.setFlownBefore()
          this.sendToOneTrust()
          localStorage.removeItem('captcha-token')
        }
      } catch (e) {
        analytics.registrationFailed()
        this.props.errorModal(e)
      }
    } else {
      this.setLoading(false)
    }
  }

  setFlownBefore = async () => {
    const data = this.context.formData
    try {
      const questionnaireAnswers = []
      Object.keys(data).forEach(item => {
        if (item.includes('category') && data[item]) {
          if (Array.isArray(data[item])){
            const obj = {
              category: '',
              answers: []
            }
            data[item].forEach(arrItem => {
              const [id, name, category] = arrItem.split('#$#')
              obj.category = category
              obj.answers = obj.answers.concat([{name, id}])
            })
            questionnaireAnswers.push(obj)
          } else {
            const [id, name, category] = data[item].split('#$#')
            const obj = {
              category,
              answers: [{
                name,
                id,
              }],
            }
            questionnaireAnswers.push(obj)
          }
        }
      })
      API.submitPersonalizationQuestionnaire({questionnaireAnswers})
      this.activatePromoCode()
    } catch (e) {
      this.props.errorModal(e)
    }
  }

  activatePromoCode = async () => {
    const {mode, code} = this.context.formData
    try {
      if (![RISE_MODE, FOUNDERS_MODE].includes(mode)) {

        //костыль для двойной активации кодов
        if (doubleCodeRedeemMap[code]) {
          await salesForceCodeSendApi(doubleCodeRedeemMap[code])
        }
        await API.activatePromocode(code)
        analytics.codeActivationSuccess()
      }
      this.done()
    } catch (e) {
      analytics.codeActivationFailed()
      this.props.errorModal(e, 'flyxo')
    }
  }

  start = () => {
    this.wrapper.current.classList.add('animation')
    setTimeout(() => {
      this.setState({
        formState: this.context.formData.mode === RISE_MODE ? FORM_LOGIN : FORM_SIGNUP,
        isLoading: false,
      })
      this.wrapper.current.classList.remove('animation')
    }, 300)
  }

  login = async () => {
    const {
      validate,
      formData: {email, password, mode, code},
    } = this.context
    if (validate(this.state.formState)) {
      try {
        const loginData = await API.login(email, password)
        analytics.loginSuccess(
          loginData.client.email,
          this.signUpData.code,
          loginData.client.name,
          loginData.client.phone
        )
        if (loginData.client && loginData.client.id) {
          analytics.sendID(loginData.client.id.toString(), 'CompleteLogin')
        }
        if (mode === PROMO_MODE) {
          if (this.props.content) {
            this.phone = loginData.client.phone
            this.activatePromoCode()
          }
          if (!this.props.content && ['FOUNDERSCARD-2021', 'HERMITAGE-2021'].includes(code)) {
            this.phone = loginData.client.phone
            this.activatePromoCode()
          }
        }
        if ([REFERRAL_MODE, MMC_MODE].includes(mode)) {
          this.phone = loginData.client.phone
          this.activatePromoCode()
        }
        if ([RISE_MODE, FOUNDERS_MODE].includes(mode)) {
          this.riseActivation()
        }
      } catch (e) {
        analytics.loginFailed()
        this.props.errorModal(e)
        this.setLoading(false)
      }
    } else {
      this.setLoading(false)
    }
  }

  riseActivation = async () => {
    try {
      if (this.context.formData.mode === RISE_MODE) {
        const exMemberData = await API.isExMember()
        if (exMemberData.exMember) {
          window.scrollTo({
            top: 'body',
            behavior: 'smooth',
          })
          this.done()
        } else {
          analytics.riseActivateFailed()
          this.props.errorModal({message: 'Sorry, you cannot activate RISE membership'}, 'flyxo')
        }
      } else {
        this.done()
      }
    } catch (e) {
      this.props.errorModal(e)
    }
  }

  recoveryPassword = async () => {
    const {email} = this.context.formData
    if (this.context.validate(this.state.formState)) {
      try {
        const resendPasswordData = await API.resendPassword(email)
        if (resendPasswordData.status) {
          this.setState({
            recoveryMessage: resendPasswordData.message,
            isLoading: false,
          })
        }
      } catch (e) {
        this.setState({
          isLoading: false,
        })
        this.props.errorModal(e)
      }
    } else {
      this.setLoading(false)
    }
  }

  done = () => {
    const {phone, mode} = this.context.formData
    const doneStatus = [RISE_MODE, FOUNDERS_MODE].includes(mode) ? CONTENT_ADDCARD : CONTENT_DONE
    this.props.switchContent(doneStatus, this.wrapper.current, phone)
  }

  // helpers for form title and description

  getFormDescription = () => {
    let {mode} = this.context.formData
    const {login, signup, or} = this.context.formContent.texts
    if (mode === RISE_MODE) return null
    const switcher = this.state.formState === FORM_SIGNUP ? login : signup
    if (this.state.formState === FORM_SIGNUP || this.state.formState === FORM_LOGIN) {
      return (
        <p className="form-switcher">
          {or}
          <button type="button" onClick={this.switchAllContent}>
            {switcher}
          </button>
        </p>
      )
    }
    return null
  }

  getFormHeader(customForm = {}) {
    const {headers} = this.context.formContent.texts
    const {formState} = this.state
    if (customForm[formState] && customForm[formState].header) return customForm[formState].header
    return headers[formState]
  }

  setCaptcha(val) {
    this.signUp(val)
    this.setState({
      withCAPTCHA: false,
      isLoading: true
    })
  }

  render() {
    const {content, noDisclaimer} = this.props
    let {isLoading, formState, withCAPTCHA, membershipAgreed} = this.state
    const {buttons} = this.context.formContent.texts
    const {code} = this.context.formData
    let customForm = getCustomFormStyle(code || 'rise')
    let formHeader = this.getFormHeader(customForm)
    return (
      <div className={classNames('form-large', customForm?.formClassName)} ref={this.wrapper}>
        {content?.form_description ?
          <div className='form-content-header' dangerouslySetInnerHTML={{__html: content.form_description}}/> :
          <h2 className="h2">{formHeader}</h2>}
        {content?.for_registration_only || content?.for_login_only ? null : this.getFormDescription()}
        <form onSubmit={this.handleSubmit} autoComplete="off">
          <span className={withCAPTCHA || isLoading ? 'no-events' : ''} >{this.currentForm}</span>
          {withCAPTCHA ? (
            <Turnstile
              className='turnstile'
              sitekey={TURNSTILE_API_KEY}
              onError={() => this.setCaptcha('error')}
              onVerify={token => this.setCaptcha(token)}
            />
          ) : null}
          {(this.state.formState === FORM_SIGNUP || this.state.formState === FORM_LOGIN) && content?.membership_legal_url ? (
            <label className='membership-toggle' htmlFor='membership'>
              <Toggle disabled={isLoading || withCAPTCHA} id='membership' checked={membershipAgreed}
                      onChange={() => this.setState({
                        membershipAgreed: !membershipAgreed
                      })}/>
              <span>I accept the <a target='_blank'
                                    href={content?.membership_legal_url || 'https://flyxo.com/legal/memberships/xo-shared-membership-agreement/'}
                                    rel="noreferrer">Membership Agreement</a></span>
            </label>
          ) : null}
          {buttons[formState] && (
            <div>
              <Button isFluid onClick={this.handleSubmit}
                      isDisabled={ (this.state.formState === 'smscode'&& !this.context.formData?.userSmsCode) || withCAPTCHA || !!(content?.membership_legal_url && !membershipAgreed && (this.state.formState === FORM_SIGNUP || this.state.formState === FORM_LOGIN))}
                      isLoading={isLoading} type="submit">
                {buttons[formState]}
              </Button>
            </div>
          )}
          {content?.disclaimer && !noDisclaimer &&
          <div className='form-content-disclaimer' dangerouslySetInnerHTML={{__html: content.disclaimer}}/>}
        </form>
      </div>
    )
  }
}

export default GiftForm
